var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"chart",staticClass:"chart"}),_c('q-inner-loading',{attrs:{"showing":!_vm.ready}},[_c('q-spinner-dots',{attrs:{"size":"50px","color":"primary"}})],1),_c('no-data-message',{attrs:{"has-data":_vm.hasData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }